import script from "./SolicitudDeMensajeria.vue?vue&type=script&setup=true&lang=js"
export * from "./SolicitudDeMensajeria.vue?vue&type=script&setup=true&lang=js"

import "./SolicitudDeMensajeria.vue?vue&type=style&index=0&id=1e83a2f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e83a2f1"]])

export default __exports__